export default __webpack_public_path__ + "47d405cbeb807e1d848f526807bdbb1c.svg";